// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2970":"3804f808b360d3df","8324":"ed445e315771a7b3","8342":"a823511bd4588e27"}[chunkId] + ".css";
};